import { BloodType } from 'gql/types';
import { PRODUCT_ID } from 'modules/products/constants/productId';

const { Dea1Negative, Dea1Positive, Unknown } = BloodType;

export const productByBloodType: Record<BloodType, number[]> = {
  [Dea1Negative]: [
    PRODUCT_ID.FFP_CANINE_NEGATIVE_DOUBLE_UNIT,
    PRODUCT_ID.FFP_CANINE_NEGATIVE_SINGLE_UNIT,
    PRODUCT_ID.PRBC_CANINE_NEGATIVE_SINGLE_UNIT,
    PRODUCT_ID.WHOLE_BLOOD_CANINE_UNIT,
    PRODUCT_ID.WHOLE_BLOOD_NEGATIVE_DOUBLE,
    PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_POOR,
    PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_RICH,
  ],
  [Dea1Positive]: [
    PRODUCT_ID.FFP_CANINE_POSITIVE_DOUBLE_UNIT,
    PRODUCT_ID.FFP_CANINE_POSITIVE_SINGLE_UNIT,
    PRODUCT_ID.PRBC_CANINE_POSITIVE_SINGLE_UNIT,
    PRODUCT_ID.WHOLE_BLOOD_CANINE_UNIT,
    PRODUCT_ID.WHOLE_BLOOD_POSITIVE_DOUBLE,
    PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_POOR,
    PRODUCT_ID.FFP_CRYOPRECIPITATE_CRYO_RICH,
  ],
  [Unknown]: [PRODUCT_ID.WHOLE_BLOOD_CANINE_UNIT],
};
